import { z } from 'zod';
import { CognitoSubSchema, SlugSchema, TenantStatusSchema, TimestampSchema } from '../common.js';
/**
 * Tenant plan — Phase 1 is a presentational field only.
 * Defaults to `'trial'` on tenant creation; Phase 2 ties this to billing /
 * seat limits.
 */
export const TenantPlanSchema = z.enum(['trial', 'pro', 'enterprise']);
export const BrandColorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, {
    message: 'Brand color must be a #RRGGBB hex color.',
});
/**
 * Tenant — see docs/data-model.md §4.1.
 * Source of truth for the tenant row in DDB (`PK = TENANT#<id>`, `SK = METADATA`).
 */
export const TenantSchema = z.object({
    tenantId: z.string().uuid(),
    name: z.string().min(1).max(120),
    slug: SlugSchema,
    logoUrl: z.string().url().nullable(),
    brandColor: BrandColorSchema.nullable().default(null),
    status: TenantStatusSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
    createdBy: CognitoSubSchema,
    notes: z.string().max(2000).nullable(),
    /** Cached count; maintained by handlers (Phase 2 may move to stream). */
    userCount: z.number().int().nonnegative(),
    /**
     * Billing plan. Phase 1 default is `'trial'`; the repo layer defaults rows
     * missing this field to `'trial'` on read for backwards compatibility with
     * pre-migration data. Phase 2 ties plan to seat limits + feature gates.
     */
    plan: TenantPlanSchema,
});
/**
 * Subset of Tenant safe to expose to any tenant member.
 *
 * Phase 1: exposes `userCount` (seats used on Home) and `plan` (plan badge on
 * Home). Internal-only fields (notes, createdBy, timestamps) stay omitted.
 */
export const TenantPublicSchema = TenantSchema.pick({
    tenantId: true,
    name: true,
    slug: true,
    logoUrl: true,
    brandColor: true,
    status: true,
    userCount: true,
    plan: true,
});
//# sourceMappingURL=tenant.js.map